// extracted by mini-css-extract-plugin
export default {"sendForm":"MessageSender_sendForm__rWxUS","textarea":"MessageSender_textarea__gQn72","button":"MessageSender_button__f2X7L"};